import useTableRequest from "../../hooks/useTableRequest";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { utilsState } from "../../sotre/redux/features/utilsSlice";
import { convertDate } from "../../utils/convertDate";
import { digitsThree } from "../../utils/price";
import Pagination from "../../components/common/pagination/Pagination";
import Table from "../../components/common/table/Table";
import Title from "../../components/common/title/Title";
import { affiliateEnrollmentsColumns } from "../../constant/tables-columns/tablesColums";
import AffiliateEnrollmentFilter from "./affiliateEnrollmentsFilter";
import PaymentStatusModal from "./sub-components/PaymentStatusModal";

export default function AffiliateEnrollmentsList() {
  const tableRequest = useTableRequest({ initialLoading: true });
  const [walletTransactions, setTransactions] = useState([]);
  const [pagination, setPagination] = useState(null);
  const { utils } = useSelector(utilsState);
  const getTransactions = async (params) => {
    const path = "admin/affiliateRegisterations";
    return tableRequest.load({ path, params: { ...params } }, (response) => {
      setTransactions(response?.data?.result.data);
      setPagination(response?.data?.result);
    });
  };

  useEffect(() => {
    getTransactions({});
  }, []);

  const [filter, setFilter] = useState();

  const filterDataHandler = (newParams) => {
    setFilter({ ...filter, ...newParams });
    const allFilter = {
      ...filter,
      ...newParams,
    };
    getTransactions(allFilter);
  };

  const data = [];

  walletTransactions?.map((item) =>
    data.push({
      ...item,
      key: item._id,
      name: item?.user?.name,
      mobile: item?.user?.mobile,
      affiliateName: item?.Affiliate?.name,
      id: item._id,
      amount: digitsThree(item?.finalPrice),
      paymentStatus: item.paymentStatus,
      level: utils?.AFFILIATE_ENROLLMENT_LEVEL[item.level]?.name,
      faPaymentStatus: utils?.PAYMENT_STATUS[item.paymentStatus]?.name,
      date: convertDate(item?.createdAt),
    })
  );

  const paymentStatusRef = useRef();

  const [affiliateEnrollments, setaffiliateEnrollments] = useState(null);

  const chnagePaymentStatus = (data) => {
    setaffiliateEnrollments(data);
    paymentStatusRef.current.showModal();
  };

  return (
    <>
      <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
        <Title title={"لیست خرید های طرح ها "} />
        <AffiliateEnrollmentFilter filterDataHandler={filterDataHandler} />
        <PaymentStatusModal
          reGetData={getTransactions}
          ref={paymentStatusRef}
          data={affiliateEnrollments}
        />
        <Pagination
          pagination={pagination}
          filterDataHandler={filterDataHandler}
        />
        <Table loading={tableRequest.loading} error={tableRequest.error} idle={tableRequest.status === "idle"} onRetry={tableRequest.retry}
          columns={affiliateEnrollmentsColumns}
          rows={data}
          onCustomFunction={chnagePaymentStatus}
          customFunctionName="ویرایش وضعیت"
        />

        <Pagination
          pagination={pagination}
          filterDataHandler={filterDataHandler}
        />
      </div>
    </>
  );
}
